import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DataService } from '../../services/data.service';
import { pages, WaiverSteps } from '../../alv-enums';
import { StoreService } from '../../services/store.service';
import Keyboard from 'simple-keyboard';
import { WaiverService } from 'src/app/services/waiver.service';

@Component({
	selector: 'customer-info',
	templateUrl: './customer-info.component.html',
	styleUrls: ['./customer-info.component.scss']
})
export class CustomerInfoComponent implements OnInit {
	@ViewChild('name') name: ElementRef;

	@Output() private pageChange = new EventEmitter<pages>();

	// Custom validation properties
	public emailValid: boolean = true;
	public emailErrorMessage: string = '';

	constructor(private dataService: DataService
		, public storeService: StoreService,public waiverService:WaiverService
	) { }

	ngOnInit() { }

	// Custom email validation function
	validateEmail(emailAddress: string): boolean {
		// Check for non-ASCII characters
		for (let i = 0; i < emailAddress.length; i++) {
			if (emailAddress[i].charCodeAt(i) > 127) {
				return false;
			}

			continue;
		}

		const pattern = /^[a-zA-Z0-9]([a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!(pattern.test(emailAddress))) {
			return false;
		};

		if (emailAddress.length > 254) {
			return false;
		}

		const atIndex = emailAddress.indexOf('@');
		if (atIndex <= 0 || atIndex === emailAddress.length - 1) {
			return false;
		}

		const localPart = emailAddress.substring(0, atIndex);
		const domain = emailAddress.substring(atIndex + 1);

		if (localPart.length > 64 || localPart[0] === '.' || localPart[localPart.length - 1] === '.') {
			return false;
		}
		if (domain[0] === '.' || domain[domain.length - 1] === '.' || domain[0] === '-' || domain[domain.length - 1] === '-') {
			return false;
		}

		// Check each domain label doesn't start or end with hyphen
		let start = 0;
		for (let i = 0; i <= domain.length; i++) {
			if (i === domain.length || domain[i] === '.') {
				if (i > start) {
					const label = domain.substring(start, i);
					if (label[0] === '-' || label[label.length - 1] === '-') {
						return false;
					}
				}
				start = i + 1;
			}
		}

		if (emailAddress.includes("..")) {
			return false;
		}
		return true;
	}

	onEmailChange(emailValue: string) {
		if (!emailValue || emailValue.trim() === '') {
			this.emailValid = true; 
			this.emailErrorMessage = '';
		} else {
			this.emailValid = this.validateEmail(emailValue);
			this.emailErrorMessage = this.emailValid ? '' : 'Please enter a valid email address';
		}
	}

	onEmailBlur(emailValue: string) {
		const trimmedValue = emailValue.trim();
		this.storeService.shoppingCart.guestEmail = trimmedValue;
		this.onEmailChange(trimmedValue);
	}

	goToPage(page: pages) {
		const self = this;

		self.pageChange.emit(page);
	}

	onSubmit() {
		const self = this;
		
		if (self.storeService.kioskSettings.showEmail) {
			const emailValue = self.storeService.shoppingCart.guestEmail;
			if (emailValue && emailValue.trim() !== '') {
				self.onEmailChange(emailValue);
				if (!self.emailValid) {
					return; 
				}
			}
		}
		
        if(self.storeService.kioskSettings.waiverRequired){
		self.goToPage(pages.Waiver);
		self.waiverService.onStepChangeForward(WaiverSteps.email)
		}
		else
		self.goToPage(pages.Pay)
		window.scroll(0,0)
	}
}
